






import { Component, Vue } from 'vue-property-decorator'

@Component
class EmptyMassage extends Vue {}

export default EmptyMassage
